var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.title
    ? _c(
        "span",
        {
          staticClass: "truncate",
          style: { color: _vm.color },
          attrs: {
            "aria-label": _vm.$t(_vm.label.key, _vm.label.attr),
            tabindex: "0",
            "data-test": "current-chapter"
          }
        },
        [_vm._v(_vm._s(_vm.title))]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }